import { useQuery } from "@tanstack/react-query";
import { fetchUserServer } from "./user";
import { api } from "~/lib/api";

export const login = async (email: string, password: string) => {
  return await api("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
    credentials: "include",
  });
};

export const useUser = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["user"],
    queryFn: fetchUserServer,
    refetchOnMount: false,
  });

  return {
    data: {
      ...data,
      //@ts-ignore
      user_id: data?.user_id,
    },
    isLoading,
    error,
  };
};
